import { css } from 'styled-components'

// shared trigger styles for FilterList and FilterRange
export const filterTriggerStyles = css`
  ${({ theme }) => css`
    position: relative;
    margin: 0;
    background: none;
    border: none;
    display: flex;
    align-items: center;
    gap: ${theme.sizes.xxs};
    padding: ${theme.sizes.xxs} ${theme.sizes.xs};
    border-radius: ${theme.borderRadii.medium};
    font-size: ${theme.fontSizes.bodySmall};
    font-weight: ${theme.fontWeights.medium};
    white-space: nowrap;
    :active {
      background: ${theme.colors.info30};
      color: ${theme.colors.primary400};

      > svg {
        > path {
          fill: ${theme.colors.primary400};
        }
      }
    }

    :focus {
      outline: 1px solid ${theme.colors.primary400};
    }

    :hover {
      background: ${theme.colors.gray70};
    }

    :disabled {
      pointer-events: all !important;
      background: none;
      color: ${theme.colors.gray100};
      > svg {
        > path {
          fill: ${theme.colors.gray100};
        }
      }
    }
  `}
`
